import { useEventCallback } from '@cian/react-utils';

import { type FC } from 'react';

import { useViewModeChange } from '@/app/shared/hooks/useViewModeChange';

import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { ListingViewModeSwitcher } from './components/ListingViewModeSwitcher';

export const ListingViewModeSwitcherContainer: FC = () => {
  const viewMode = useListingLayoutViewModeSelector();

  const switchToNextView = useViewModeChange();

  const switchToHybrid = useEventCallback(() => {
    switchToNextView('hybrid');
  });

  if (viewMode !== 'list') {
    return null;
  }

  return <ListingViewModeSwitcher onSwitch={switchToHybrid} />;
};
